import axios from "axios";
import Swal from "sweetalert2";

export const LoggerUtils = () => {


    const openGame = async (serverId) => {
        try {
            const formDataToSend = new FormData();
            formDataToSend.append("server_id", serverId);
            formDataToSend.append("isAdobeAir", true);

            let playServerAxios = await axios.post(`${process.env.REACT_APP_API_URL}v1/logged/server/play`, formDataToSend, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem("accessToken")}`
                }
            });

            if (localStorage.getItem("isBrowser")) {
                await Swal.fire("", "Não é possível fazer isso através do navegador.", "error");
                throw new Error("Invalid agent!");
            }

          //  Swal.fire("bombom", JSON.stringify(playServerAxios.data.data.server_name), "error");

            window.jsInterop.handleOpenGameCall({
                play_url: playServerAxios.data.data.game_swf_link,
                server_name: playServerAxios.data.data.server_name
            });
        } catch (e) {
            throw e;
        }
    };

    return {
        openGame
    }
};